import React, { Component } from 'react'
import autobind from 'autobind-decorator'

@autobind
class WorkSidebarLoader extends Component {
  render () {
    return (
      <div className='WorkSidebarLoader'>
        <div className='workPlaceholder__intro'>
          <div className='workPlaceholder__head'>
            <div className='workPlaceholder__circle' />
            <div>
              <span className='workPlaceholder__line' />
              <span className='workPlaceholder__line workPlaceholder__line--small' />
            </div>
          </div>
          <div className='workPlaceholder__bullet' />
        </div>
        <div className='workPlaceholder__content'>
          <span className='workPlaceholder__line workPlaceholder__line--title' />
          <span className='workPlaceholder__line workPlaceholder__line--desc' />
          <span className='workPlaceholder__line workPlaceholder__line--desc' />
          <span className='workPlaceholder__line workPlaceholder__line--desc' />
        </div>
      </div>
    )
  }
}

export default WorkSidebarLoader

WorkSidebarLoader.propTypes = {

}



// WEBPACK FOOTER //
// ./components/work/WorkSidebarLoader.js